import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Dexie from 'dexie';
import ImageUpload from './components/ImageUpload.vue'
import UploadedImage from './components/UploadedImage.vue'
import SavedInput from './components/SavedInput.vue'
import SavedInputLong from './components/SavedInputLong.vue'
import SavedInputNarratorFriendly from './components/SavedInputNarratorFriendly.vue'
import SavedInputLongNarratorFriendly from './components/SavedInputLongNarratorFriendly.vue'
import RecordAnswer from './components/RecordAnswer.vue'
import PlayAudio from './components/PlayAudio.vue'
import ImageOptionSlider from './components/ImageOptionSlider.vue'

Vue.config.productionTip = false
var eventHub = new Vue()

var db = new Dexie('book');
db.version(1).stores({
  images: 'id,blob',
});
db.version(2).stores({
  inputs: 'id,text',
});
db.version(3).stores({
  sounds: 'id,blob',
});
db.version(4).stores({
  options: 'id,option',
});
db.open()

var pageData = {
  regular : {
    pages: 219,
    1 : {
      videos: ["p6/V4.mp4"]
    },
    2 : {
      videos: ["p6/V4A.mp4"]
    },
    3 : {
      videos: ["p7/V5.mp4"]
    },
    4 : {
      videos: ["p7/V6.mp4"]
    },
    5 : {
      videos: ["p8/V8.mp4", "p8/V9.mp4", "p8/V10.mp4"]
    },
    6: {
      videos: ["p8/V11.mp4"]
    },
    51: {
      videos: ["p51/V14.mp4"]
    },
    52: {
      videos: ["p52/V15A.mp4", "p52/V15B.mp4", "p52/V15C.mp4"]
    },
    53: {
      videos: ["p53-57/V16.mp4"]
    },
    54: {
      videos: ["p53-57/V16.mp4"]
    },
    55: {
      videos: ["p53-57/V16.mp4"]
    },
    56: {
      videos: ["p53-57/V16.mp4"]
    },
    57: {
      videos: ["p53-57/V16.mp4"]
    },
    58: {
      videos: ["p58/V17.mp4", "p58/V18.mp4", "p58/V19.mp4", "p58/V20.mp4", "p58/V21.mp4"]
    },
    59: {
      videos: ["p59/V22.mp4", "p59/V23.mp4", "p59/V24.mp4", "p59/V25.mp4", "p59/V26.mp4", "p59/V27.mp4"]
    },
    60: {
      videos: ["p60/V28.mp4", "p60/V29.mp4", "p60/V30.mp4"]
    },
    61: {
      videos: ["p61/V31.mp4", "p61/V32.mp4", "p61/V33.mp4"]
    },
    62: {
      videos: ["p62/V34.mp4", "p62/V35.mp4", "p62/V36.mp4", "p62/V37.mp4", "p62/V38.mp4", "p62/V39.mp4", "p62/V40.mp4"]
    },
    63: {
      videos: ["p63-65/V41.mp4", "p63-65/V42.mp4"]
    },
    64: {
      videos: ["p63-65/V41.mp4", "p63-65/V42.mp4"]
    },
    65: {
      videos: ["p63-65/V41.mp4", "p63-65/V42.mp4"]
    },
    66: {
      videos: ["p66/V43.mp4", "p66/V44.mp4"]
    },
    67: {
      videos: []
    },
    68: {
      videos: ["p68-69/V45.mp4", "p68-69/V46.mp4"]
    },
    69: {
      videos: ["p68-69/V45.mp4", "p68-69/V46.mp4"]
    },
    70: {
      videos: ["p70/V47.mp4"]
    },
    71: {
      videos: ["p71-74/V48.mp4", "p71-74/V49.mp4", "p71-74/V50.mp4", "p71-74/V51.mp4", "p71-74/V52.mp4", "p71-74/V53.mp4", "p71/V54.mp4"]
    },
    72: {
      videos: ["p71-74/V48.mp4", "p71-74/V49.mp4", "p71-74/V50.mp4", "p71-74/V51.mp4", "p71-74/V52.mp4", "p71-74/V53.mp4", "p71/V55.mp4"]
    },
    73: {
      videos: ["p71-74/V48.mp4", "p71-74/V49.mp4", "p71-74/V50.mp4", "p71-74/V51.mp4", "p71-74/V52.mp4", "p71-74/V53.mp4", "p71/V56.mp4"]
    },
    74: {
      videos: ["p71-74/V48.mp4", "p71-74/V49.mp4", "p71-74/V50.mp4", "p71-74/V51.mp4", "p71-74/V52.mp4", "p71-74/V53.mp4", "p71/V57.mp4"]
    },
    75: {
      videos: ["p75-76/V58.mp4", "p75-76/V59.mp4", "p75-76/V60.mp4", "p75-76/V61.mp4", "p75-76/V62.mp4", "p75-76/V63.mp4", 
      "p75-76/V64.mp4", "p75-76/V65.mp4", "p75-76/V66.mp4", "p75/V67.mp4",  "p75/V68.mp4"]
    },
    76: {
      videos: ["p75-76/V58.mp4", "p75-76/V59.mp4", "p75-76/V60.mp4", "p75-76/V61.mp4", "p75-76/V62.mp4", "p75-76/V63.mp4", 
      "p75-76/V64.mp4", "p75-76/V65.mp4", "p75-76/V66.mp4", "p76/V69.mp4",  "p76/V70.mp4"]
    },
    77: {
      videos: ["p77/V71.mp4", "p77/V72.mp4", "p77/V73.mp4", "p77/V74.mp4", "p77/V75.mp4"]
    },
    78: {
      videos: ["p78/V76.mp4", "p78/V77.mp4"]
    },
    79: {
      videos: ["p79/V78.mp4", "p79/V79.mp4", "p79/V80.mp4", "p79/V81.mp4", "p79/V82.mp4", "p79/V83.mp4", "p79/V84.mp4", 
      "p79/V85.mp4", "p79/V86.mp4", "p79/V87.mp4"]
    },
    80: {
      videos: ["p80/V88.mp4", "p80/V89.mp4", "p80/V90.mp4"]
    },
    81: {
      videos: ["p81-82/V91.mp4", "p81-82/V92.mp4", "p81-82/V93.mp4", "p81-82/V94.mp4", "p81-82/V95.mp4", "p81-82/V96.mp4", 
      "p81/V97.mp4", "p81/V98.mp4", "p81/V99.mp4"]
    },
    82: {
      videos: ["p81-82/V91.mp4", "p81-82/V92.mp4", "p81-82/V93.mp4", "p81-82/V94.mp4", "p81-82/V95.mp4", "p81-82/V96.mp4", 
      "p82/V100.mp4", "p82/V101.mp4"]
    },
    83: {
      videos: ["p83/V102.mp4"]
    },
    84: {
      videos: ["p84-85/V103.mp4"]
    },
    85: {
      videos: ["p84-85/V103.mp4"]
    },
    86: {
      videos: ["p86-88/V104.mp4", "p86-88/V105.mp4", "p86-88/V106.mp4", "p86-88/V107.mp4", "p86/V108.mp4", "p86/V109.mp4", "p86/V110.mp4"]
    },
    87: {
      videos: ["p86-88/V104.mp4", "p86-88/V105.mp4", "p86-88/V106.mp4", "p86-88/V107.mp4", "p87/V111.mp4", "p87/V112.mp4", "p87/V113.mp4"]
    },
    88: {
      videos: ["p86-88/V104.mp4", "p86-88/V105.mp4", "p86-88/V106.mp4", "p86-88/V107.mp4", "p87/V114.mp4", "p87/V115.mp4", "p87/V116.mp4"]
    },
    89: {
      videos: ["p89/V117.mp4", "p89/V118.mp4", "p89/V119.mp4", "p89/V120.mp4", "p89/V121.mp4"]
    },
    90: {
      videos: ["p90/V122.mp4", "p90/V123.mp4", "p90/V124.mp4", "p90/V125.mp4", "p90/V126.mp4"]
    },
    91: {
      videos: ["p91/V127.mp4", "p91/V128.mp4", "p91/V129.mp4", "p91/V130.mp4", "p91/V131.mp4"]
    },
    92: {
      videos: ["p92/V132.mp4"]
    },
    93: {
      videos: ["p93/V133.mp4", "p93/V134.mp4", "p93/V135.mp4", "p93/V136.mp4", "p93/V137.mp4"]
    }
  },
  autism : {
    pages: 219,
    51: {
      audios: ["p51/PAG51-01.mp3", "p51/PAG51-02.mp3"]
    },
    52: {
      audios: ["p52/PAG52-01.mp3"]
    },
    53: {
      audios: ["p53/PAG53-01.mp3"]
    },
    54: {
      audios: ["p54/PAG54-01.mp3"]
    },
    55: {
      audios: ["p55/PAG55-01.mp3"]
    },
    56: {
      audios: ["p56/PAG56-01.mp3"]
    },
    57: {
      audios: ["p57/PAG57-01.mp3"]
    },
    58: {
      audios: ["p58/PAG58-01.mp3", "p58/PAG58-02.mp3", "p58/PAG58-03.mp3", "p58/PAG58-04.mp3", "p58/PAG58-05.mp3", "p58/PAG58-06.mp3", "p58/PAG58-07.mp3", "p59/PAG59-01.mp3"]
    },
    59: {
      audios: ["p58/PAG58-01.mp3", "p58/PAG58-04.mp3", "p58/PAG58-05.mp3", "p59/PAG59-02.mp3", "p59/PAG59-03.mp3", "p59/PAG59-04.mp3"]
    },
    60: {
      audios: ["p58/PAG58-01.mp3", "p58/PAG58-04.mp3", "p58/PAG58-05.mp3", "p59/PAG59-05.mp3", "p59/PAG59-06.mp3"]
    },
    61: {
      audios: ["p60/PAG60-01.mp3", "p60/PAG60-02.mp3"]
    },
    62: {},
    63: {
      audios: ["p62/PAG62-01.mp3", "p62/PAG62-02.mp3"]
    },
    64: {
      audios: ["p63/PAG63-01.mp3", "p63/PAG63-02.mp3", "p63/PAG63-03.mp3", "p63/PAG63-04.mp3", "p63/PAG63-05.mp3", "p63/PAG63-06.mp3", 
      "p63/PAG63-07.mp3", "p63/PAG63-08.mp3", "p63/PAG63-09.mp3", "p63/PAG63-10.mp3", "p63/PAG63-11.mp3"]
    },
    65: {
      audios: ["p64/PAG64-01.mp3", "p64/PAG64-02.mp3", "p64/PAG64-03.mp3", "p64/PAG64-04.mp3", "p64/PAG64-05.mp3", "p64/PAG64-06.mp3", 
      "p64/PAG64-07.mp3", "p64/PAG64-08.mp3", "p64/PAG64-09.mp3", "p64/PAG64-10.mp3", "p64/PAG64-11.mp3", "p64/PAG64-12.mp3"]
    },
    66: {
      audios: ["p65/PAG65-01.mp3", "p65/PAG65-02.mp3", "p65/PAG65-03.mp3", "p65/PAG65-04.mp3", "p65/PAG65-05.mp3", "p65/PAG65-06.mp3", 
      "p65/PAG65-07.mp3", "p65/PAG65-08.mp3"]
    },
    67: {
      audios: ["p66/PAG66-01.mp3", "p66/PAG66-02.mp3", "p66/PAG66-03.mp3", "p66/PAG66-04.mp3", "p66/PAG66-05.mp3", "p66/PAG66-06.mp3", 
      "p66/PAG66-07.mp3", "p66/PAG66-08.mp3", "p66/PAG66-09.mp3", "p66/PAG66-10.mp3", "p66/PAG66-11.mp3"]
    },
    68: {
      audios: ["p67/PAG67-01.mp3", "p67/PAG67-02.mp3", "p67/PAG67-03.mp3", "p67/PAG67-04.mp3", "p67/PAG67-05.mp3"]
    },
    69: {
      audios: ["p68/PAG68-01.mp3", "p68/PAG68-02.mp3", "p68/PAG68-03.mp3", "p68/PAG68-04.mp3", "p68/PAG68-05.mp3", "p68/PAG68-06.mp3"]
    },
    70: {
      audios: ["p69/PAG69-01.mp3", "p69/PAG69-02.mp3", "p69/PAG69-03.mp3"]
    },
    71: {
      audios: ["p70/PAG70-01.mp3", "p70/PAG70-02.mp3", "p70/PAG70-03.mp3"]
    },
    72: {
      audios: ["p71/PAG71-01.mp3", "p71/PAG71-02.mp3", "p71/PAG71-03.mp3", "p71/PAG71-04.mp3", "p71/PAG71-05.mp3", "p71/PAG71-06.mp3"]
    },
    73: {
      audios: ["p72/PAG72-01.mp3", "p72/PAG72-02.mp3", "p72/PAG72-03.mp3", "p72/PAG72-04.mp3", "p72/PAG72-05.mp3", "p72/PAG72-06.mp3"]
    },
    74: {
      audios: ["p73/PAG73-01.mp3", "p73/PAG73-02.mp3", "p73/PAG73-03.mp3", "p73/PAG73-04.mp3", "p73/PAG73-05.mp3", "p73/PAG73-06.mp3"]
    },
    75: {
      audios: ["p74/PAG74-01.mp3", "p74/PAG74-02.mp3", "p74/PAG74-03.mp3", "p74/PAG74-04.mp3", "p74/PAG74-05.mp3", "p74/PAG74-06.mp3"]
    },
    76: {
      audios: ["p75/PAG75-01.mp3", "p75/PAG75-02.mp3", "p75/PAG75-03.mp3", "p75/PAG75-04.mp3", "p75/PAG75-05.mp3", "p75/PAG75-06.mp3"]
    },
    77: {
      audios: ["p76/PAG76-01.mp3", "p76/PAG76-02.mp3", "p76/PAG76-03.mp3", "p76/PAG76-04.mp3", "p76/PAG76-05.mp3", "p76/PAG76-06.mp3"]
    },
    78: {
      audios: ["p77/PAG77-01.mp3", "p77/PAG77-02.mp3"]
    },
    79: {
      audios: ["p78/PAG78-01.mp3"]
    },
    80: {
      audios: ["p79/PAG79-01.mp3", "p79/PAG79-02.mp3", "p79/PAG79-03.mp3", "p79/PAG79-04.mp3", "p79/PAG79-05.mp3", "p79/PAG79-06.mp3"]
    },
    81: {
      audios: ["p80/PAG80-01.mp3", "p80/PAG80-02.mp3", "p80/PAG80-03.mp3", "p80/PAG80-04.mp3"]
    },
    82: {
      audios: ["p81/PAG81-01.mp3", "p81/PAG81-02.mp3", "p81/PAG81-03.mp3", "p81/PAG81-04.mp3", "p81/PAG81-05.mp3", "p81/PAG81-06.mp3", 
      "p81/PAG81-07.mp3", "p81/PAG81-08.mp3", "p81/PAG81-09.mp3", "p81/PAG81-10.mp3"]
    },
    83: {
      audios: ["p82/PAG82-01.mp3", "p82/PAG82-02.mp3", "p82/PAG82-03.mp3", "p82/PAG82-04.mp3", "p82/PAG82-05.mp3", "p82/PAG82-06.mp3", 
      "p82/PAG82-07.mp3", "p82/PAG82-08.mp3", "p82/PAG82-09.mp3"]
    },
    84: {
      audios: ["p83/PAG83-01.mp3", "p83/PAG83-02.mp3", "p83/PAG83-03.mp3", "p83/PAG83-04.mp3", "p83/PAG83-05.mp3", "p83/PAG83-06.mp3", 
      "p83/PAG83-07.mp3"]
    },
    85: {
      audios: ["p84/PAG84-01.mp3", "p84/PAG84-02.mp3", "p84/PAG84-03.mp3", "p84/PAG84-04.mp3", "p84/PAG84-05.mp3"]
    },
    86: {
      audios: ["p85/PAG85-01.mp3", "p85/PAG85-02.mp3", "p85/PAG85-03.mp3", "p85/PAG85-04.mp3"]
    },
    87: {
      audios: ["p86/PAG86-01.mp3", "p86/PAG86-02.mp3", "p86/PAG86-03.mp3", "p86/PAG86-04.mp3", "p86/PAG86-05.mp3", "p86/PAG86-06.mp3", 
      "p86/PAG86-07.mp3", "p86/PAG86-08.mp3"]
    },
    88: {
      audios: ["p87/PAG87-01.mp3", "p87/PAG87-02.mp3", "p87/PAG87-03.mp3", "p87/PAG87-04.mp3", "p87/PAG87-05.mp3", "p87/PAG87-06.mp3", 
      "p87/PAG87-07.mp3"]
    },
    89: {
      audios: ["p88/PAG88-01.mp3", "p88/PAG88-02.mp3", "p88/PAG88-03.mp3", "p88/PAG88-04.mp3", "p88/PAG88-05.mp3", "p88/PAG88-06.mp3", 
      "p88/PAG88-07.mp3", "p88/PAG88-08.mp3"]
    },
    90: {
      audios: ["p89/PAG89-01.mp3", "p89/PAG89-02.mp3", "p89/PAG89-03.mp3", "p89/PAG89-04.mp3", "p89/PAG89-05.mp3", "p89/PAG89-06.mp3", 
      "p89/PAG89-07.mp3"]
    },
    91: {
      audios: ["p90/PAG90-01.mp3", "p90/PAG90-02.mp3", "p90/PAG90-03.mp3", "p90/PAG90-04.mp3", "p90/PAG90-05.mp3", "p90/PAG90-06.mp3"]
    },
    92: {
      audios: ["p91/PAG91-01.mp3", "p91/PAG91-02.mp3", "p91/PAG91-03.mp3", "p91/PAG91-04.mp3", "p91/PAG91-05.mp3", "p91/PAG91-06.mp3"]
    },
    93: {
      audios: ["p92/PAG92-01.mp3", "p92/PAG92-02.mp3"]
    },
    94: {
      audios: ["p93/PAG93-01.mp3"]
    },
    95: {
    },
    96: {

    }
  },
  vision: {
    pages: 219,
  }
}

Vue.component('image-upload', ImageUpload)
Vue.component('uploaded-image', UploadedImage)
Vue.component('saved-input', SavedInput)
Vue.component('saved-input-long', SavedInputLong)
Vue.component('saved-input-narrator-friendly', SavedInputNarratorFriendly)
Vue.component('saved-input-long-narrator-friendly', SavedInputLongNarratorFriendly)
Vue.component('record-answer', RecordAnswer)
Vue.component('play-audio', PlayAudio)
Vue.component('image-option-slider', ImageOptionSlider)

Vue.prototype.$db = db
Vue.prototype.$pageData = pageData
Vue.prototype.$eventHub = eventHub

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
